import { TFunction } from 'i18next';
import { z } from 'zod';
import { MAX_INVESTIGATION_NAME } from './config';

export const getInvestigationBaseSchema = (t: TFunction) => {
  return z.object({
    name: z
      .string()
      .min(1, { message: t('Validation.Specify', { field: 'InvestigationName' }) })
      .max(MAX_INVESTIGATION_NAME, {
        message: t('Validation.Maximum', { count: MAX_INVESTIGATION_NAME, unit: 'character' }),
      }),
    oneSecLog: z.boolean(),
  });
};
